import DG from '2gis-maps';
import bp from  './brakePoints';

let $mapCtr = $('.js-map-ctr'),
	mapData = window.mapData,
	center = $mapCtr.data('center'),
	$categories = $('.js-nav-category'),
	$items = $('.js-map-item'),
	activeCategory = 0,
	markers = DG.featureGroup(),
	markerClicked = 0;

let map = DG.map('js-map', {
	center: center,
	zoom: 16,
	// scrollWheelZoom: false,
	doubleClickZoom: false,
	boxZoom: false,
	// geoclicker: false,
	zoomControl: true,
	scrollWheelZoom: false,
	fullscreenControl: false
}).on('popupClose', function() {
	$categories.find('[data-item=' + item.id + ']').removeClass('active');
});

// DG.marker(center).addTo(map);

// возвращает все элементы или элементы указанной категории
function getItemsByCategory(category) {
	if (category === 0) {
		return mapData.landmarks;
	}
	return mapData.landmarks.filter(item => item.category === category);
}

// показывает маркеры относящиеся к выбранной категории
// категория указывается в переменной activeCategory
// activeCategory === 0 если показываются все маркеры
// (корень списка)
function showMarkers() {
	markers.removeFrom(map);
	markers = DG.featureGroup();
	
	let items = getItemsByCategory(activeCategory);
	
	items.forEach(item => {
		let myIcon = DG.icon({
			iconUrl: mapData.categories[item.category].marker,
			iconSize: [20, 20],
			iconAnchor: [10, 10],
			popupAnchor: [10, 0]
		});
		let marker = DG.marker(item.coordinates, {
			icon: myIcon
		}).bindPopup(item.name, {
			maxWidth: 350,
			minWidth: 320
		});
		
		// привязка события на маркер для выделения пункта в меню,
		// так же в переменную markerClicked записывается id элемента
		// для последующего переоткрытия попапа в случае если элемент
		// находится в другой категории (изначално был открыт в корне)
		marker.on('click', function(e) {
			markerClicked = item.id;
			showItem(item);
		});
		marker.addTo(markers);
	});
	
	markers.addTo(map);
	// ставим масштаб, достаточный для вмещения всех активных маркеров
	map.fitBounds(markers.getBounds());
}

// открывает меню категории и показывает принадлежащие ей маркеры
function showCategory(categoryId) {
	if (categoryId === activeCategory) {
		return false;
	}
	activeCategory = categoryId;
	
	if (categoryId > 0) {
		//открываем меню категории
		let menu = $categories.filter('[data-category=' + activeCategory + ']');
		menu.removeAttr('aria-hidden');
		
		if (markerClicked > 0) {
			let $menu = $(menu);
			// выделяем пункт меню и показываем попап на маркере
			$menu.find('[data-item]').removeClass('active');
			$menu.find('[data-item=' + markerClicked + ']').addClass('active');
		}
	}
	
	//показываем маркеры
	showMarkers();
}


function showItem(item) {
	if (activeCategory !== item.category) {
		// показывается категория со всеми относящимися макрерами
		// меню со списком элементов
		showCategory(item.category);
	}
	if (markerClicked > 0) {
		// при клике на маркер и после показа всех маркеров категории
		// и меню со сиском пунктов открывается попап с описанием над
		// этим маркером
		// let item = mapData.landmarks.filter(item => item.id === markerClicked);
		showPopup(item);
	}
}

function showPopup(item) {
	let popup = DG.popup({
		maxWidth: 240,
		minWidth: 240,
		
	}).setLatLng(item.coordinates).setContent(item.name).openOn(map);

	// выделяем пункт меню и показываем попап на маркере
	$items.removeClass('active');
	$items.filter('[data-item=' + item.id + ']').addClass('active');
	markerClicked = 0;
}

// показ списка категории и маркеров в данной категории
$('.js-map-category').click(function() {
	showCategory($(this).data('category'));
});

$items.click(function(e) {
	if (!e.target.closest('.map-item__link')) {
		let $c = $(this),
			id = $c.data('item'),
			item = mapData.landmarks.filter(item => item.id===id);
		showPopup(item[0]);
	}
	
});
// возврат в корень
$('.js-map-back').click(function(e) {
	e.preventDefault();
	let $c = $(this),
		$parent = $c.parents('.js-nav-category');
	$parent[0].setAttribute('aria-hidden', 'true');
	activeCategory = 0;
	showMarkers();
});

// изначально показываем все маркеры
showMarkers();



/// скрываю меню на мобильных

$(window).on('bpChanged',function(e) {
	$('js-map').addClass('menu-hidden');
});
